import React  from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import Home from "./Components/Home";
import NotFound from "./Components/NotFound";
import Letter from "./Components/Groups/Letter";
import Project from "./Components/Pages/Projects/Project";
import Projectdetail from "./Components/Pages/Projects/Projectdetail";
import Resume from "./Components/Pages/About/Resume";
// import car from "./Components/SVGs/Car.svg";
// import carbreak from "./Components/SVGs/break.svg";
// import caracc from "./Components/SVGs/accelator.svg";

function App() {
  // const [position, setPosition] = useState({ x: 0, y: 0 }); // Tracks the car's position
  // const [rotation, setRotation] = useState(0); // Tracks car rotation
  // const [gear, setGear] = useState(1); // Gear level

  // // Key control movement
  // useEffect(() => {
  //   const handleKeyDown = (e) => {
  //     if (e.key === "ArrowUp") {
  //       setPosition((prev) => ({ ...prev, y: prev.y - 10 * gear }));
  //       setRotation(90); // Face up
  //     }
  //     if (e.key === "ArrowDown") {
  //       setPosition((prev) => ({ ...prev, y: prev.y + 10 * gear }));
  //       setRotation(-90); // Face down
  //     }
  //     if (e.key === "ArrowLeft") {
  //       setPosition((prev) => ({ ...prev, x: prev.x - 10 * gear }));
  //       setRotation(0); // Face left
  //     }
  //     if (e.key === "ArrowRight") {
  //       setPosition((prev) => ({ ...prev, x: prev.x + 10 * gear }));
  //       setRotation(180); // Face right
  //     }
  //   };

  //   window.addEventListener("keydown", handleKeyDown);
  //   return () => window.removeEventListener("keydown", handleKeyDown);
  // }, [gear]);

  // const increaseGear = () => {
  //   setGear((prev) => Math.min(prev + 1, 5)); // Max gear: 5
  // };

  // const decreaseGear = () => {
  //   setGear((prev) => Math.max(prev - 1, 1)); // Min gear: 1
  // };

  return (
    <div className="App">

      {/* Portfolio */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/letter" element={<Letter />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/projects" element={<Project />} />
        <Route path="/projects/:id" element={<Projectdetail />} />
        <Route path="/resume" element={<Resume />} />
      </Routes>
    </div>
  );
}

export default App;
